import { useState, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import RoleBasedGuard from './RoleBasedGuard';
import useAuth from '../../hooks/useAuth';
import Login from '../Login/Login';

type AuthGuardProps = {
  children: ReactNode;
};

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated } = useAuth();

  const { pathname } = useLocation();
  const [requestedLocation, setRequestedLocation] = useState<string | null>(
    null
  );
  const accessRole: TRole[] = []; // TODO:

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }

    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return (
    <RoleBasedGuard accessibleRoles={accessRole}>{children}</RoleBasedGuard>
  );
}
